<template>
  <div>
    <div class="views-view-flexbox row dataset" ref="top-dataset" id="top-dataset">
      <div class="col-12" v-if="error">{{ error }}</div>
      <div class="col-12 mb-15 mb-30 col-sm-6 col-md-4 views-row" v-for="row in this.displayedCompanies" :key="row.id" >
        <article class="node node--address node--address--teaser view-mode--teaser">
          <a :href='"/companyguide/" + row.id'>
            <div class="image" v-if="row.img != null">
              <div class="field field--field-image field--type--entity-reference">
                <article>
                  <div class="field field--image field--type--image">
                    <img @error="showFallbackImage" :src='row.img' :alt='row.name' typeof="foaf:Image" height="315">
                  </div>
                </article>
              </div>
            </div>
            <div class="content-wrapper">
              <div class="title">{{ row.name }}</div>
              <div>
                <div class="field field--field-p-location field--type--entity-reference-revisions">
                  <div class="paragraph paragraph--type--pt-location paragraph--view-mode--info-short">
                    <div class="field field--field-address-details field--type--address">
                      <p class="address" translate="no"><span class="address-line1">{{ row.street }} {{ row.number}}</span><br>
                        <span class="postal-code">{{ row.postal }}</span> <span class="locality">{{ row.city }}</span><br>
                      </p>
                    </div>
                    <div class="field field--field-website field--type--companyguide-field" v-if="row.website">
                      <a :href='row.website' target="_blank">{{ row.website }}</a>
                    </div>
                    <div class="field field--field-phone field--type--companyguide-field" v-if="row.phone">
                      <a :href='"tel:" + row.phone'>{{ row.phone }}</a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="read-more">
              Lees meer
            </div>
          </a>
        </article>
      </div>
    </div>
    <div class="col-12 view" v-if="pages.length > 1">
      <nav class="pager" role="navigation" aria-labelledby="pagination-heading">
        <h4 id="pagination-heading" class="visually-hidden">Paginering</h4>
        <ul class="pager__items js-pager__items">
          <li class="pager__item pager__item--first" @click="page = 1" v-if="page !== 1">
            <a title="Ga naar eerste pagina" @click="scrollMeTo('top-dataset')">
              <span class="visually-hidden">Eerste pagina</span>
              <span aria-hidden="true">« Eerste</span>
            </a>
          </li>
          <li class="pager__item pager__item--previous" v-if="page !== 1" @click="scrollMeTo('top-dataset')">
            <a title="Ga naar vorige pagina" rel="prev" @click="page--">
              <span class="visually-hidden">Vorige pagina</span>
              <span aria-hidden="true">‹‹</span>
            </a>
          </li>
          <li class="pager__item" :class="pageNumber === page ? 'is-active' : ''" v-bind:key="pageNumber" v-for="pageNumber in pages.slice(page-1, page+5)" @click="page = pageNumber">
            <a :title="'Go to page' + pageNumber" @click="scrollMeTo('top-dataset')">
            <span class="visually-hidden">
              Pagina
            </span>{{ pageNumber }}</a>
          </li>
          <li class="pager__item pager__item--next" @click="scrollMeTo('top-dataset')">
            <a title="Ga naar volgende pagina" rel="next" @click="page++" v-if="page < pages.length">
              <span class="visually-hidden">Volgende pagina</span>
              <span aria-hidden="true">››</span>
            </a>
          </li>
          <li class="pager__item pager__item--last" @click="scrollMeTo('top-dataset')">
            <a title="Ga naar laatste pagina" @click="page = pages.length" v-if="page < pages.length">
              <span class="visually-hidden">Laatste pagina</span>
              <span aria-hidden="true">Laatste »</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Dataset',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      companies: [],
      error: '',
      page: 1,
      perPage: 9,
      pages: []
    }
  },
  computed: {
    displayedCompanies () {
      const sortedCompanies = _.orderBy(this.companies, [company => company.name.toString().toLowerCase()]);

      return this.paginate(sortedCompanies)
    }
  },
  watch: {
    companies () {
      this.setPages()
    }
  },
  methods: {
    async fetchDataset (id) {
      let results = []
      const response = await fetch('/companyguide/dataset/' + this.id, {
        headers: {
          Accept: 'application/json'
        }
      })
      results = await response.json()
      return results
    },
    showFallbackImage (event) {
      event.target.src = '/profiles/ocp_kickstart/themes/ocp_theme/assets/dist/img/placeholder.png'
    },
    setPages () {
      const numberOfPages = Math.ceil(this.companies.length / this.perPage)
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },
    paginate (companies) {
      const page = this.page
      const perPage = this.perPage
      const from = (page * perPage) - perPage
      const to = (page * perPage)
      return companies.slice(from, to)
    },
    scrollMeTo (refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop

      window.scrollTo({ top, behavior: 'smooth' })
    }
  },
  // deze functie wordt automatisch opgestart na het laden van de component
  mounted: function () {
    // eigen async fetch functie
    this.fetchDataset(this.id).then(results => {
      if ('error' in results && results.error.length) {
        this.error = results.error
      } else if ('bedrijven' in results && results.bedrijven.length) {
        // transform data if necessary
        const data = results.bedrijven
        for (let i = 0; i < data.length; i++) {
          const company = {
            id: data[i].ondnr,
            name: data[i].bedrijfsnaam,
            street: data[i].straat,
            number: data[i].huisnr,
            postal: data[i].postcode,
            city: data[i].deelgemeente,
            img: data[i].cover ? data[i].cover : '/profiles/ocp_kickstart/themes/ocp_theme/assets/dist/img/placeholder.png',
            website: data[i].website,
            phone: data[i].tel
          }
          this.companies.push(company)
        }
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dataset .node.view-mode--teaser a {
    box-shadow: none;
  }

  .dataset .field--type--image img {
    height: 220px;
    width: 100%;
    object-fit: cover;
  }

  .dataset .field--field-website {
    word-break: break-word;
  }

</style>
